import '~/features/ShopLoginButton/init';

import {defineInitFunction} from '~/utils/defineInitFunction';

import {initCustomerAccountsSignUp} from './initCustomerAccountsSignUp';

(() =>
  defineInitFunction(
    'initCustomerAccountsSignUp',
    initCustomerAccountsSignUp,
  ))();
